<template>
	<div>
		<app-header></app-header>
		<div class="app flex-row align-items-center">
			<div class="container">
				<b-row class="justify-content-center">
					<b-col md="8">
						<b-card-group>
							<b-card no-body class="p-4">
								<b-card-body>
									<b-form>
										<h1>Réinitialiser votre mot de passe</h1>
										<p class="text-muted"></p>
										<el-alert
											title="Si vous avez un compte avec cette adresse email, un lien de récupération de votre mot de passe vous sera envoyé"
											type="info"
											show-icon
											:closable="false"
										>
										</el-alert
										><br />
										<el-alert :title="message.texte" :type="message.type" show-icon :closable="false" v-if="resetted">
										</el-alert
										><br />

										<b-input-group class="mb-3">
											<b-input-group-prepend
												><b-input-group-text><i class="icon-user"></i></b-input-group-text
											></b-input-group-prepend>
											<b-form-input
												type="text"
												class="form-control"
												placeholder="Taper votre adresse email"
												autocomplete="username email"
												v-model="credentials.email"
											/>
										</b-input-group>
										<b-input-group class="mb-4">
											<b-input-group-prepend
												><b-input-group-text><i class="icon-lock"></i></b-input-group-text
											></b-input-group-prepend>
											<b-form-input
												type="password"
												class="form-control"
												placeholder="Taper Votre Nouveau Mot de Passe"
												autocomplete="current-password"
												v-model="credentials.password"
											/>
										</b-input-group>
										<b-input-group class="mb-4">
											<b-input-group-prepend
												><b-input-group-text><i class="icon-lock"></i></b-input-group-text
											></b-input-group-prepend>
											<b-form-input
												type="password"
												class="form-control"
												placeholder="Retaper Votre Mot de Passe"
												autocomplete="current-password"
												v-model="credentials.password_confirmation"
											/>
										</b-input-group>
										<b-row>
											<b-col cols="6">
												<el-button type="primary" :loading="resetting" @click="onsendreset()">Envoyer</el-button>
											</b-col>
											<b-col cols="6" class="text-right">
												<!-- <b-button variant="link" class="px-0">Mot de passe oublié ?</b-button> -->
											</b-col>
										</b-row>
									</b-form>
								</b-card-body>
							</b-card>
							<!-- <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Inscription</h2>
                  <p>Vous n'avez pas encore d'espace fournisseur ? Inscrivez vous pour soumettre votre dossier</p>
                  <b-button @click="goToRegister()" variant="primary" class="active mt-3">S'inscrire</b-button>
                </div>
              </b-card-body>
            </b-card> -->
						</b-card-group>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AppHeader from "../../containers/AppHeader";
import axios from "axios";

export default {
	name: "Login",
	components: {
		AppHeader
	},

	data: function() {
		return {
			credentials: {
				email: "",
				password: "",
				token: "",
				password_confirmation: ""
			},
			message: {
				texte: "",
				type: ""
			},
			resetting: false,
			resetted: false
		};
	},
	methods: {
		async onsendreset() {
			this.resetting = true;
			axios
				.post(this.$store.state.baseurl + "/password/reset", this.credentials, {
					headers: {
						"Content-Type": "application/json"
					}
				})
				.then(resp => {
					console.log(resp.data.data);
					this.resetting = false;
					this.resetted = true;
					if (resp.data.data == "passwords.reset") {
						this.message.type = "success";
						this.message.texte = "Mot de passe modifié avec Succès.";
					} else {
						this.message.type = "error";
						this.message.texte = "Echec de modification de mot de passe";
					}
				})
				.catch(err => {
					this.resetting = false;
					this.resetted = true;
					this.message.type = "error";
					this.message.texte = "Une erreur s'est produite, veuillez reéssayer";
				});
		}
	},
	computed: {},
	mounted() {
		this.credentials.token = this.$route.params.token;
	}
};
</script>

<style scoped>
.menu-item {
	padding-right: 20px;
}
</style>
